const cyclicKey = String(process.env.GATSBY_CYCLIC_KEY).toUpperCase();
const keyPartitions = cyclicKey.split("-");
export const tenant = keyPartitions[0];
export const salesChannel = keyPartitions[1];
